import styles from './primaryBackButton.module.css';
import { Button } from '@pvh-components/button';
import { ReactNode } from 'react';
import { WithTestId } from '../../../../types';
import { toKebabCase } from '../../../../utils';

export interface PrimaryBackButtonProps extends WithTestId {
  onClick: () => void;
  children: ReactNode | string;
}

const PrimaryBackButton = ({
  onClick,
  children,
  dataTestIdPrefix,
}: PrimaryBackButtonProps) => (
  <div className={styles.backButtonPrimary}>
    <Button
      type="button"
      success={true}
      onClick={onClick}
      dataTestIdPrefix={toKebabCase(dataTestIdPrefix, 'backButton')}
    >
      {children}
    </Button>
  </div>
);

export default PrimaryBackButton;
